import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { IBillingAccount } from '@dch/billing-business-logic';
import {
  resetPaymentData,
  setSelectedBillingAccount,
} from 'src/app/state/actions';
import { ApplicationState } from 'src/app/state/reducers';
import { selectSelectedBillingAccount } from 'src/app/state/selectors/billing-balance.selector';
import { BillingAddressService } from '../services/billing-address-service';

@Component({
  selector: 'my-bill-account-selection',
  templateUrl: './my-bill-account-selection.component.html',
  standalone: false,
})
export class MyBillAccountSelectionComponent implements OnInit {
  @Input() billingAccounts: Array<IBillingAccount>;
  readonly selectedBillingAccount$ = this.store.select(
    selectSelectedBillingAccount
  );
  selectedAccountNumber = '';

  constructor(
    private router: Router,
    private store: Store<ApplicationState>,
    private billingAddressService: BillingAddressService
  ) {}

  ngOnInit() {
    this.selectedBillingAccount$.subscribe((selectedBillingAccount) => {
      if (selectedBillingAccount) {
        this.selectedAccountNumber = selectedBillingAccount.accountNumber;
      }
    });
  }

  getFormattedAddress(billingAccount: IBillingAccount) {
    return this.billingAddressService.formatAddress(billingAccount.address);
  }

  onChangeOfAccountNumber(selectedAccountNumber: string) {
    if (selectedAccountNumber === '') {
      this.router.navigate(['overview']);
    } else {
      this.store.dispatch(
        setSelectedBillingAccount({
          billingAccountNumber: selectedAccountNumber,
        })
      );
      this.store.dispatch(resetPaymentData());
      this.router.navigate(['overview/fls/' + selectedAccountNumber]);
    }
  }
}
